export default __webpack_public_path__ + "static/media/close_circle.a02b0bed.svg";